import { useRef } from 'react'
import { forceInitGlobalState } from '@libs/client/hooks'
import { storeConfigurationKey } from '@libs/client/helpers/constant'
import { StoreConfiguration } from './useStoreConfiguration'

type InitCheckoutStateOptions = {
  storeConfiguration: StoreConfiguration
}

/**
 * Reinitializes all URL-param-derived checkout state on every page mount.
 * Runs exactly once per component lifetime (useRef guard) so mid-session
 * re-renders do not clobber values the user has already edited.
 *
 * Only savedPaymentMethodKey is conditionally written: it is provided by the
 * checkout page (SSR header decryption) and intentionally left alone on the
 * cart page, where no header decryption occurs.
 */
export const useInitState = ({ storeConfiguration }: InitCheckoutStateOptions) => {
  const initialized = useRef(false)
  if (!initialized.current) {
    initialized.current = true

    forceInitGlobalState(storeConfigurationKey, storeConfiguration)
  }
}
